import React from 'react';
import { ReactComponent as DHLLogo } from '../../resources/images/dhl_logo.svg';
import './styles/LandingStyle.css';
import './styles/LoadingScreenStyle.css';
import '../base-styles/fonts.css';
import Spinner from 'react-bootstrap/Spinner';
import { useTypedSelector, useLogger } from '../../hooks';
import { useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { languageMap } from '../../maps/languageMap';

const LoadingScreen: React.FC = () => {
  const [setLogger] = useLogger();

  const authenticating = useTypedSelector((state) => {
    return state.session.authenticating;
  });
  const language = useTypedSelector((state) => {
    return state.session.language;
  });
  const settingUpScanners = useTypedSelector(({ devices }) => {
    return devices.settingUpScanners;
  });
  const settingUpLocker = useTypedSelector(({ devices }) => {
    return devices.settingUpLocker;
  });
  //On Loading
  useEffect(() => {
    console.log('on loading');
    setLogger();
  }, []);
  //#endregion
  const renderFeedback = (loadingStatus: boolean) => {
    if (loadingStatus) {
      return (
        <Spinner
          className="setup-status-icon"
          animation="grow"
          variant="danger"
        />
      );
    }
    return <FaCheckCircle className="setup-status-icon" />;
  };
  return (
    <div id="landing" className="main-container">
      <div className="landing-image-container">
        <div
          key="loading-image"
          className="landing-image-container landing-image landing1 active"
        />
      </div>
      <div className="banner-setup" />
      <DHLLogo className="dhl-logo" />
      <div className="title-container-setup">
        <p className="title-secondary">
          {languageMap.loading_screen.instructions[language]}
        </p>
      </div>
      <div className="setup-feedback-container">
        <div className="setup-item-container">
          <p className="setup-item-text">CRA: </p>
          {renderFeedback(authenticating)}
        </div>
        <div className="setup-item-container">
          <p className="setup-item-text">Scanner: </p>
          {renderFeedback(settingUpScanners)}
        </div>
        <div className="setup-item-container">
          <p className="setup-item-text">Locker: </p>
          {renderFeedback(settingUpLocker)}
        </div>
      </div>
    </div>
  );
};

export { LoadingScreen };
